<ng-container *ngIf="isSuccess">
	<table cellpadding="0" cellspacing="0" class="emailVerified">
		<tbody>
			<tr>
				<td>
					<table align="center" border="0" cellpadding="0" cellspacing="0">
						<tbody>
							<tr>
								<td>
									<div class="course-icon" style="margin-top: 10%">
										<svg class="fill-icon">
											<use xlink:href="assets/svg/icon-sprite.svg#profile-check"></use>
										</svg>
									</div>
								</td>
							</tr>
							<tr>
								<td>
									<h2 class="title">Verification Success</h2>
								</td>
							</tr>
							<tr>
								<td>
									<p>Thank you for your support,{{ successMessage }}</p>
									<p>You can now proceed to your home page</p>
								</td>
							</tr>
							<tr>
								<td>
									<div style="border-top: 1px solid #777; height: 1px; margin-top: 30px"></div>
								</td>
							</tr>
						</tbody>
					</table>
				</td>
			</tr>
		</tbody>
	</table>
	<table
		class="main-bg-light text-center top-0"
		align="center"
		border="0"
		cellpadding="0"
		cellspacing="0"
		width="100%"
	>
		<tbody>
			<tr>
				<td style="padding: 30px">
					<div>
						<a routerLink="/auth/login" (click)="logout()"
							><h4 class="title" style="margin: 0; text-align: center">Take Me Login</h4></a
						>
					</div>

					<div style="border-top: 1px solid #ddd; margin: 20px auto 0"></div>
				</td>
			</tr>
		</tbody>
	</table>
</ng-container>
<ng-container>
	<!-- error-404 start-->
	<div class="error-wrapper" *ngIf="isError">
		<div class="container">
			<img class="img-100" src="assets/images/other-images/sad.png" alt="" />
			<div class="error-heading">
				<h2 class="headline font-danger">404</h2>
			</div>
			<div class="col-md-8 offset-md-2">
				<p class="sub-content">{{ error }}</p>
			</div>
			<div *ngIf="isExpired">
				<a class="btn btn-danger-gradien btn-lg" (click)="Expired()"> Resend Email Verification </a>
			</div>
			<div *ngIf="!isExpired">
				<a class="btn btn-danger-gradien btn-lg" routerLink="/auth/login">BACK TO HOME PAGE</a>
			</div>
		</div>
	</div>
	<!-- error-404 end      -->
</ng-container>
